import { render } from "./serveurprisecommande.vue?vue&type=template&id=2965f4ba"
import script from "./serveurprisecommande.vue?vue&type=script&lang=js"
export * from "./serveurprisecommande.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__